import * as types from "../actions/actionTypes";

const LAST_USED_KEY = "lastSetId";

const readLastUsed = () => {
  try {
    const value = Number(localStorage.getItem(LAST_USED_KEY));
    return Number.isInteger(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
};

const storeLastUsed = (setId) => {
  try {
    if (setId) localStorage.setItem(LAST_USED_KEY, String(setId));
    else localStorage.removeItem(LAST_USED_KEY);
  } catch {
    // storage unavailable: the choice lasts for this page load
  }
};

// The host's named sets (see actions/setsActions.js); most recently used first.
export const createInitialSetsState = () => ({
  items: [],
  isLoaded: false,
  loadFailed: false,
  lastUsedId: readLastUsed(), // the set the bookmark button adds to
});

const bySort = (a, b) => (a.Sort ?? 0) - (b.Sort ?? 0);

const normalize = (set) => ({ ...set, Songs: [...(set.Songs || [])].sort(bySort) });

export default function setsReducer(state = createInitialSetsState(), action) {
  switch (action.type) {
    case types.SETS_LOAD_SUCCESS:
      return { ...state, items: (action.sets || []).map(normalize), isLoaded: true, loadFailed: false };

    case types.SETS_LOAD_FAILED:
      return { ...state, isLoaded: true, loadFailed: true };

    case types.SET_SAVED: {
      const set = normalize(action.set);
      const exists = state.items.some((item) => item.Id === set.Id);
      return {
        ...state,
        items: exists ? state.items.map((item) => (item.Id === set.Id ? set : item)) : [set, ...state.items],
      };
    }

    case types.SET_REMOVED: {
      const items = state.items.filter((item) => item.Id !== action.setId);
      const lastUsedId = state.lastUsedId === action.setId ? null : state.lastUsedId;
      if (lastUsedId !== state.lastUsedId) storeLastUsed(lastUsedId);
      return { ...state, items, lastUsedId };
    }

    case types.SETS_LAST_USED:
      storeLastUsed(action.setId);
      return { ...state, lastUsedId: action.setId };

    case types.SONG_DELETED:
      return {
        ...state,
        items: state.items.map((set) => ({ ...set, Songs: set.Songs.filter((song) => song.Id !== action.songId) })),
      };

    case types.SONG_UPDATED:
      return {
        ...state,
        items: state.items.map((set) => ({
          ...set,
          Songs: set.Songs.map((song) => (song.Id === action.song.Id ? { ...song, Title: action.song.Title, Artist: action.song.Artist, Key: action.song.Key } : song)),
        })),
      };

    case types.SETS_CLEAR:
      return { ...state, items: [], isLoaded: false, loadFailed: false };

    default:
      return state;
  }
}
